import {
  createApiClient,
  createAuthApi,
  createUserApi,
} from "@charisol-spark/client-core";
import { config } from "@/config";

/**
 * The admin app's bound API client + service instances.
 *
 * A single module-level instance (like packages/frontend/src/services/api.ts's
 * module-level `api`), built from @charisol-spark/client-core's factories —
 * see client-core's index.ts for why these are factories rather than
 * ready-made singletons (the frontend app needs its own, differently
 * configured instances).
 */
export const api = createApiClient(config.apiUrl, () => {
  // Redirect to admin's own login route (but only if not already there) —
  // the admin app's routes live at "/", not "/auth/login" like the frontend.
  const currentPath = window.location.pathname;
  if (currentPath !== "/login") {
    window.location.href = "/login?session=expired";
  }
});

export const authApi = createAuthApi(api);
export const userApi = createUserApi(api);

export {
  ApiClientError,
  getErrorMessage,
  isMfaChallenge,
} from "@charisol-spark/client-core";
export type {
  LoginOutcome,
  LoginResponse,
  MfaChallenge,
} from "@charisol-spark/client-core";
